import * as React from 'react';
import * as I18n from 'i18n-js';
import { V3 } from '../api_request';
import userRegionUrl from '../shared/user_region_url';
import CoreLink from '@reverbdotcom/commons/dist/components/core_link';
import Article from '../discovery/article';
import URLHelpers from '../shared/url_helpers';

const CATEGORIES = [
  {
    url: '/news?category_name=News+and+Reviews',
    translation: 'newsAndReviews',
  },
  {
    url: '/news?category_name=Tips+and+How-To%27s',
    translation: 'tips',
  },
  {
    url: '/news?category_name=Interviews',
    translation: 'interviews',
  },
  {
    url: '/news?category_name=Gear+History',
    translation: 'gearHistory',
  },
  {
    url: '/news?category_name=Demos',
    translation: 'demos',
  },
  {
    url: '/videos',
    translation: 'videos',
  },
];

interface State {
  articles: Article[];
}

export default class NewsDropdown extends React.Component<{}, State> {
  constructor(props) {
    super(props);

    this.state = {
      articles: [],
    };
  }

  componentDidMount() {
    V3.get(URLHelpers.articlesRecentlyFeaturedPath()).then((res) => {
      this.setState({ articles: res?.articles });
    });
  }

  renderArticles() {
    return this.state.articles.map((article, index) => {
      return (
        <li key={`article-${index}`}>
          <CoreLink
            className="news-dropdown__article__link"
            to={article._links.web.href}
          >
            <img
              className="news-dropdown__article__image"
              src={article._links.mobile_small.href}
              alt={article.title}
            />
            <div className="pl-1">
              {article.title}
            </div>
          </CoreLink>
        </li>
      );
    });
  }

  renderCategories() {
    return CATEGORIES.map((category) => {
      return (
        <li key={category.translation}>
          <CoreLink
            className="news-dropdown__category__link"
            to={userRegionUrl(category.url)}
          >
            {I18n.t(`discovery.newsDropdown.${category.translation}`)}
          </CoreLink>
        </li>
      );
    });
  }

  render() {
    return (
      <div className="d-flex">
        <div className="news-dropdown__articles">
          <ul>
            {this.renderArticles()}
            <li className="padding-1">
              <CoreLink
                className="button button--orange width-100 size-90"
                to={userRegionUrl('/news')}
              >
                {I18n.t('discovery.newsDropdown.viewAll')}
              </CoreLink>
            </li>
          </ul>
        </div>

        <div>
          <ul>
            {this.renderCategories()}
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/new_header/news_dropdown.tsx